import { CreditCard } from '@mui/icons-material'

import { ReactComponent as VisaCardIcon } from '@/assets/icons/visa-card.svg'
import { ReactComponent as MasterCardIcon } from '@/assets/icons/master-card.svg'

const getCreditCardIcon = (brand = 'visa') => {
  switch (brand) {
    case 'visa':
      return <VisaCardIcon />
    case 'mastercard':
      return <MasterCardIcon />
    default:
      return <CreditCard />
  }
}

export default getCreditCardIcon
